module.exports = __webpack_public_path__ + "img/baby-shoulder-transverse.deff7553.png";